import { PageTitle } from "@/components/PageTitle";
import { Button } from "@/components/ui";
import {
  SuperPageEligibilityValues,
  SuperPageDetailValues,
  SuperPageServices,
} from "@/services/bedrock/SuperPageServices";
import { URLS, useClearVideoPageCache } from "@/utils";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { FormProvider, useForm } from "react-hook-form";
import { SuperPageDetailsForm, SuperPageEligibilityForm, SuperPageTabs } from ".";
import { toast } from "sonner";

const SuperPageCreateForm: React.FC = () => {
  const history = useHistory();
  const [step, setStep] = useState<1 | 2>(1);
  const { clearVideoPageCache } = useClearVideoPageCache();
  type FormValues = SuperPageDetailValues & SuperPageEligibilityValues;
  const methods = useForm<FormValues>({
    defaultValues: {
      id: null,
      title: "",
      categories: [],
      videoScript: null,
      originalMedia: null,
      allowCtaChange: false,
      allowThemeChange: false,
      callToAction: null,
      contentPageTheme: null,
      eligibilityCriterions: [],
    },
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const handleCreateSubmit = (form: FormValues) => {
    SuperPageServices.createSuperPage(form)
      .then(result => {
        const url =
          URLS.coach.superPage.replace(":id", result.id.toString()) + `?tab=${SuperPageTabs.PerformanceRoster.value}`;
        history.push(url);
        clearVideoPageCache();
      })
      .catch(error => {
        console.error("Error creating Super Page:", error);
        toast.error("Error creating Super Page");
      });
  };

  return (
    <div className="flex flex-col gap-6">
      <PageTitle
        title="New Super Page"
        breadcrumbs={[
          { name: "Library", link: URLS.coach.videoPages },
          { name: "Super Pages", link: URLS.coach.superPages },
        ]}
      />

      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(handleCreateSubmit)} className="flex flex-col gap-6 self-center">
          {step === 1 && <SuperPageDetailsForm />}
          {step === 2 && <SuperPageEligibilityForm />}

          <div className="flex gap-2 justify-end">
            {step === 1 ? (
              <>
                <Button type="button" loading={isSubmitting} onClick={() => handleSubmit(_data => setStep(2))()}>
                  Next
                </Button>
              </>
            ) : (
              <>
                <Button type="button" variant="outline" onClick={() => setStep(1)}>
                  Back
                </Button>
                <Button type="submit" loading={isSubmitting}>
                  Create Super Page
                </Button>
              </>
            )}
          </div>
        </form>
      </FormProvider>
    </div>
  );
};

export { SuperPageCreateForm };
